module.exports = __webpack_public_path__ + "img/better_control.a06c3e21.svg";